var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('task-modal',{attrs:{"availableProject":_vm.project,"hasProject":true,"task":_vm.task}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }